/**
 * The order of these enum values matters!
 */
export enum CellType {
    ASYNC_TEXT,
    ASYNC_STATUS,
    TEXT,
    CHECK,
    CHECKBOX,
    STATUS,
    PROGRESS,
    MEDIA,
    LINK,
    BOOLEAN
}

export abstract class Cell {
    constructor(public readonly type: CellType) {}
}
